import { Injectable } from "@nestjs/common"
import { InjectRepository } from "@nestjs/typeorm"
import { Repository } from "typeorm"
import { CommonResponseModel, JobWorkDto } from "@project-management-system/shared-models"
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object"
import { JobWorkEntity } from "./job-work-entity"


@Injectable()
export class JobWorkService {
    constructor(
        @InjectRepository(JobWorkEntity)
        private repo: Repository<JobWorkEntity>,

    ) { }


    async createJobWork(req: JobWorkDto): Promise<CommonResponseModel> {
        try {
            const check = await this.repo.find({ where: { name: req.name } });
            if (check.length > 0) {
                return new CommonResponseModel(false, 0, 'Name already exists');
            }

            const entity = new JobWorkEntity();
            entity.name = req.name;
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;

            const save = await this.repo.save(entity);

            if (!save) {
                return new CommonResponseModel(false, 0, 'Something went wrong in Job Work creation', []);
            } else {
                return new CommonResponseModel(true, 1, 'Created successfully', save);
            }

        } catch (err) {
            throw err;
        }
    }


    async getAllData(): Promise<CommonResponseModel> {
        const data = await this.repo.find();
        if (data) {
          return new CommonResponseModel(true, 1, "Data Retrived", data);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }
    

    async updateJobWork(req: JobWorkDto): Promise<CommonResponseModel> {
        try {
            const check = await this.repo.find({ where: { name: req.name } });
            if (check.length > 0) {
                return new CommonResponseModel(false, 0, 'Name already exists');
            }
            
            let updateResult;
            updateResult = await this.repo.update(
                { id: req.id },
                {
                    name: req.name,
                }
            );

            if (updateResult.affected > 0) {
                return new CommonResponseModel(true, 11, 'Updated successfully', updateResult);
            } else {
                return new CommonResponseModel(false, 11, 'Update failed', []);
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }


    async activateOrDeactivateJobWork(req: JobWorkDto): Promise<CommonResponseModel> {
        try {
            console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Data information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Job Work is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Job Work is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Job Work is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Job Work is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }



}